/**
 * Классы админки (54c). Базовые примитивы — в `@ui/classes`.
 * Варианты задаются полным набором, без конкатенации «база + override».
 */

export const sectionCard = 'mb-4 rounded-panel border border-line bg-white p-4'

/** Сегментированный переключатель (вкладки внутри карточки). */
export const segBar = 'mb-3 inline-flex gap-1 rounded-pill bg-soft p-1'
export const seg =
  'cursor-pointer rounded-pill px-3.5 py-1.5 text-small font-semibold transition-colors'
export const segActive = 'bg-white text-ink shadow-sm'
export const segIdle = 'text-muted hover:text-ink'
export const segDisabled = 'cursor-not-allowed opacity-50'
export const filterBar = 'mb-3 flex flex-wrap items-center gap-2.5'
export const filterChip =
  'inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-pill bg-soft px-3 py-1.5 text-small font-semibold text-ink transition-colors'
/** Активный фильтр-чип: полный набор классов (без конфликтов с базовым). */
export const filterChipActive =
  'inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-pill border border-ink bg-ink px-3 py-1.5 text-small font-semibold text-white transition-colors'
export const moduleToggle = 'flex cursor-pointer items-center gap-1.5 rounded-pill bg-soft px-2.5 py-1 text-small'
// Варианты таба задаются ПОЛНЫМ набором: база без цвета, иначе bg-white/
// border-lineStrong/text-inkSoft перебивают активные классы (порядок в CSS).
export const shiftTab =
  'inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-pill border px-3.5 py-1.5 text-small font-semibold transition-colors'
export const shiftTabInactive = 'border-lineStrong bg-white text-inkSoft'
export const shiftTabActive = 'border-ink bg-ink text-white'
export const closeShiftBtn =
  'cursor-pointer whitespace-nowrap rounded-md border border-red-500 bg-white px-3 py-1.5 font-semibold text-red-500'
export const wizardApplyBtn =
  'inline-flex cursor-pointer items-center gap-2 rounded-card border border-ok bg-ok px-3 py-2 font-semibold text-white'
export const credInput =
  'rounded-card border border-lineStrong px-2.5 py-2 text-base2 text-ink placeholder:text-muted'
export const modInput = 'rounded-card border border-lineStrong px-2 py-1.5 text-sm text-ink'
export const priceInput =
  'w-24 rounded-md border border-lineStrong px-1.5 py-1 text-right text-small text-ink'
export const versionRow = 'flex flex-wrap items-center justify-between gap-3 border-b border-line py-2'
export const eqRow = 'my-0.5 text-small'
export const eqBtn =
  'cursor-pointer rounded-card border border-lineStrong bg-white px-3 py-1.5 text-small font-semibold text-ink'
export const eqSmallBtn =
  'cursor-pointer rounded-md border border-lineStrong bg-white px-2 py-0.5 text-tiny font-semibold text-muted2'
export const eqField = 'w-24 rounded-md border border-lineStrong px-1.5 py-1 text-small text-ink'
/** Подпись-колонка формы (бывший eqFieldStyle: label с флекс-колонкой). */
export const eqFieldLabel = 'flex min-w-[180px] flex-col gap-1 text-small'

export const okBanner =
  'my-2 rounded-card border border-green-200 bg-green-50 px-3 py-2 text-small font-semibold text-green-800'
export const errBanner =
  'my-2 rounded-card border border-warnLine bg-red-50 px-3 py-2 text-small font-semibold text-dangerDark'
export const microText = 'text-micro text-muted'
export const mutedText = 'text-small text-muted'

export const badgeActive =
  'ml-2 rounded-md border border-ok px-1.5 py-0.5 text-tiny font-semibold text-okDark'
export const badgeRepaid =
  'rounded-md border border-green-600 bg-green-100 px-2 py-0.5 text-tiny font-bold text-green-800'
export const badgeIncoming =
  'rounded-md border border-amber-500 bg-amber-100 px-2 py-0.5 text-tiny font-semibold text-warnFg'
export const badgeMark = 'rounded-md bg-sky-100 px-1.5 py-0.5 text-tiny text-info'
export const badgeYes =
  'rounded-md border border-green-200 bg-green-50 px-1.5 py-0.5 text-tiny font-semibold text-okDark'
export const badgeNo = 'rounded-md bg-soft px-1.5 py-0.5 text-tiny text-muted'
/**
 * Компактная плашка «кг». Внешние отступы намеренно не заданы: в flex-колонке
 * они давали сдвиг, а в строке текста отступ добавляет место вызова.
 */
export const badgeWeight =
  'inline-flex items-center gap-0.5 whitespace-nowrap rounded bg-amber-100 px-1 py-0 text-[10px] font-bold leading-4 text-warnFg'
export const badgePosCreated =
  'whitespace-nowrap rounded border border-yellow-500 bg-yellow-300 px-1 py-0 text-[10px] font-bold leading-4 text-yellow-900'
